import { OnInit, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import {
  Observation,
  PatientObservation,
  OrderObservation,
  AuditoriaObservation,
} from "../../../model/observation";
import { AdmissionService } from "../../../services/admission.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-medical-appointment-observation-dialog",
  templateUrl: "medical-appointment-observation-dialog.component.html",
  styleUrls: ["./medical-appointment-observation-dialog.component.css"],
})
export class MedicalAppointmenObservationDialogComponent implements OnInit {
  orderObservationForm: FormGroup;
  auditoriaObservationForm: FormGroup;
  orderObservations: OrderObservation[];
  patientObservations: PatientObservation[];
  auditoriaObservations: AuditoriaObservation[];

  onlyAuditoriaObservationReadOnly: boolean = false;

  constructor(
    private admissionService: AdmissionService,
    private formBuilder: FormBuilder,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<MedicalAppointmenObservationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.onlyAuditoriaObservationReadOnly =
      data.onlyAuditoriaObservationReadOnly;

    if (!this.onlyAuditoriaObservationReadOnly) {
      this.orderObservationForm = this.formBuilder.group({
        OrderObservation: ["", Validators.required],
      });

      this.auditoriaObservationForm = this.formBuilder.group({
        AuditoriaObservation: ["", Validators.required],
      });
    }
  }

  get f() {
    return this.orderObservationForm.controls;
  }
  get faud() {
    return this.auditoriaObservationForm.controls;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async saveAuditoriaObservation() {
    try {
      if (
        !this.auditoriaObservationForm.controls.AuditoriaObservation.invalid
      ) {
        await this.admissionService.observationsSave(
          this.data.medicalAppointmentId,
          "",
          "",
          this.auditoriaObservationForm.controls.AuditoriaObservation.value
        );

        this.auditoriaObservationForm.controls.AuditoriaObservation.setErrors(
          null
        );
        this.auditoriaObservationForm.controls.AuditoriaObservation.setValue(
          null
        );
        await this.getObservations();
        this.notificationToastService.success(
          "Se agregó la observación correctamente",
          "Observaciones de turno"
        );
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Observaciones de turno"
      );
    }
  }

  async saveOrderObservation() {
    try {
      if (!this.orderObservationForm.controls.OrderObservation.invalid) {
        await this.admissionService.observationsSave(
          this.data.medicalAppointmentId,
          this.orderObservationForm.controls.OrderObservation.value,
          "",
          ""
        );
        this.orderObservationForm.controls.OrderObservation.setErrors(null);
        this.orderObservationForm.controls.OrderObservation.setValue(null);
        await this.getObservations();
        this.notificationToastService.success(
          "Se agregó la observación correctamente",
          "Observaciones de turno"
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Observaciones de turno"
      );
    }
  }

  async ngOnInit() {
    await this.getObservations();
  }

  private async getObservations() {
    try {
      const observation = this.data.observation
        ? this.data.observation
        : await this.admissionService.getObservations(
            this.data.medicalAppointmentId
          );
      this.orderObservations = observation.OrderObservations;
      this.patientObservations = observation.PatientObservations;
      this.auditoriaObservations = observation.AuditoriaObservations;

      if (
        this.data &&
        this.data.editLastObservation &&
        this.orderObservations &&
        this.orderObservations.length > 0
      ) {
        this.orderObservationForm.patchValue({
          OrderObservation:
            this.orderObservations[this.orderObservations.length - 1]
              .Observation,
        });
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Observaciones de turno"
      );
    }
  }
}
